import FavoriteIcon from "@mui/icons-material/Favorite";
import QuestionAnswerIcon from "@mui/icons-material/QuestionAnswer";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { Tab, Tabs } from "@mui/material";
import React, { Suspense, useState } from "react";
import { useAppSelector } from "store/hooks";
import { IEventData } from "types";
import { TabContainerDetail } from "../../Events.styles";
import {
  DetailBanner,
  EventDetailBannerContainer,
  InsightContainer,
  InsightItem,
} from "../NewEvents.styles";

const DetailTab = React.lazy(() => import("./EventDetailTab"));
const ImpactTab = React.lazy(() => import("./EventImpactTab"));

interface EventDetailProps {
  selectedEvent: IEventData;
  draftEvent: boolean;
  userType: string;
  bannerErrors: { [key: number]: boolean };
  handleBannerError: (eventId: number) => void;
  onPublishClick: (event: IEventData) => void;
}

const EventDetail: React.FC<EventDetailProps> = (props) => {
  const { selectedEvent, bannerErrors, handleBannerError } = props;
  const user = useAppSelector((state) => state.user);
  const userId = user.id;
  const isHost = selectedEvent.users.some(
    (u) => u.user_id === userId && u.part_type === "Host"
  );

  const [activeTab, setActiveTab] = useState<"Detail" | "Impact">("Detail");

  return (
    <>
      <EventDetailBannerContainer>
        {!bannerErrors[selectedEvent.activity.id] ? (
          <DetailBanner
            src={
              selectedEvent.visuals?.[0]?.image_url ??
              "https://blocks.astratic.com/img/general-img-landscape.png"
            }
            alt="banner"
            onError={() => handleBannerError(selectedEvent.activity.id)}
          />
        ) : (
          "No Image Found"
        )}
      </EventDetailBannerContainer>
      <InsightContainer>
        <InsightItem>
          <VisibilityIcon />
          1000 Viewed
        </InsightItem>

        <InsightItem>
          <QuestionAnswerIcon />
          300 Comments
        </InsightItem>

        <InsightItem>
          <FavoriteIcon />
          1000 Likes
        </InsightItem>
      </InsightContainer>

      <TabContainerDetail style={{ height: "auto", marginTop: "1rem" }}>
        <Tabs
          value={activeTab}
          onChange={(_, v) => setActiveTab(v)}
          TabIndicatorProps={{ sx: { backgroundColor: "#FE2F67" } }}
          sx={{ borderBottom: "1px solid #FE2F67", minWidth: "100%" }}
        >
          <Tab
            value="Detail"
            label={<span style={{ color: "#FE2F67" }}>Detail</span>}
          />
          {isHost && (
            <Tab
              value="Impact"
              label={<span style={{ color: "#FE2F67" }}>Impact</span>}
            />
          )}
        </Tabs>
      </TabContainerDetail>

      <Suspense fallback={null}>
        {activeTab === "Detail" && <DetailTab {...props} />}
        {activeTab === "Impact" && isHost && (
          <ImpactTab selectedEvent={props.selectedEvent} />
        )}
      </Suspense>
    </>
  );
};

export default EventDetail;
